import { List } from "@mui/material"
import React, { useEffect } from "react"
import { Box, Button, DataGrid, Grid, IconButton, IGridColDef, ListItem, ListItemText, NumberField, Stack, TextField } from "src/components"
import Card from "src/components/Card"
import CardContent from "src/components/CardContent"
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { translate } from "src/i18n/tHelper"
import VwKurumMailGonderimAyarlariDTO from "src/models/Settings/Generals/VwKurumMailGonderimAyarlariDTO"
import RecordInfo from "src/parts/Genel/record.info"
import { useKurumMailGonderimAyarlariListesiQuery, useKurumMailGonderimAyarSilMutation } from "src/services/geneltanimlar/KurumMailGonderimAyarlariApi"
import { useAppDispatch, useAppSelector } from "src/store"
import { KurumMailGonderimAyarlariSlice } from "src/store/Slices/GenelTanimlar/KurumMailGonderimAyarlariSlice"
import { styled } from '@mui/material/styles';
import MailIcon from '@mui/icons-material/Mail';
import SnackbarUtils from "src/utils/SnackbarUtils"
import { string } from "yup"
import { useConfirmation } from "src/base/ConfirmationDialog/ConfirmationService"
interface KurumMailGonderimAyarlariProps { }
const translatePath = "pages|KurumMailGonderimAyarlari"
const HtmlTooltip: React.FC<any> = styled(({ className, ...props }: any) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: 12,
        border: '1px solid #dadde9',
    },
}));
const KurumMailGonderimAyarlariListe = (props: KurumMailGonderimAyarlariProps): JSX.Element => {

    const state = useAppSelector(state => state.kurumMailGonderimAyarlari);
    const dispatch = useAppDispatch();
    const query = useKurumMailGonderimAyarlariListesiQuery()
    const [sil, silState] = useKurumMailGonderimAyarSilMutation();
    const confirm = useConfirmation();

    useEffect(() => {
        if (query.isSuccess && query.data) {
            dispatch(KurumMailGonderimAyarlariSlice.actions.setData(query.data));
        }
    }, [query.isSuccess, query.data, dispatch])

    const columns: IGridColDef<VwKurumMailGonderimAyarlariDTO>[] = [
        {
            field: "organizasyonAdi",
            headerName: translate(translatePath, "Organizasyon"),
            width: 200,
            flex: 1,
        },
        {
            field: "kurumAdi",
            headerName: translate(translatePath, "Kurum"),
            width: 200,
            flex: 1,
        },
        {
            field: "mailAdres",
            headerName: translate(translatePath, "Mail Adresleri"),
            width: 80,
            align: "center",
            renderCell(params) {
                const mailler = params.formattedValue?.split(";");

                return (
                    <HtmlTooltip
                        hover
                        title={
                            <React.Fragment>
                                <Box display={'grid'}>
                                    <List>

                                        {
                                            mailler.map(m => (
                                                <ListItem disablePadding>
                                                    <ListItemText primary={m} />
                                                </ListItem>

                                            ))
                                        }
                                    </List>

                                </Box>
                            </React.Fragment>
                        }
                    >
                        <IconButton color="primary">
                            <MailIcon />
                        </IconButton>
                    </HtmlTooltip>

                )

            },
        },
        {
            field: "gonderimYontemDetay",
            headerName: translate(translatePath, "Gönderim Yöntemi"),
            width: 150,

        },
        {
            field: "gonderimSureYontemDetay",
            headerName: translate(translatePath, "Gönderim Süre Yöntemi"),
            width: 150,

        },
        {
            field: "gonderimAktif",
            headerName: translate(translatePath, "Aktif"),
            width: 70,
            type: "boolean",
            filterable: false,
            resizable: false,
            sortable: false,
            disableColumnMenu: true,
            valueGetter: (params) => {
                return params.row?.gonderimAktif === "E";
            }

        },
        {
            field: "action",
            headerName: "",
            width: 80,
            disableColumnMenu: true,
            sortable: false,
            resizable: false,
            filterable: false,
            renderCell(params) {
                return (
                    <Stack direction="row">
                        <IconButton customType="edit" onClick={(e) => { editHandler(e, params.row); }} />
                        <IconButton customType="delete" onClick={(e) => { deleteHandler(e, params.row); }} />
                        <RecordInfo
                            id={params.row.id}
                            eklemeTarihi={params.row.eklemeTarihi}
                            ekleyenKullanici={params.row.ekleyenKullanici}
                            guncellemeTarihi={params.row.guncellemeTarihi}
                            guncelleyenKullanici={params.row.guncelleyenKullanici}
                        />
                    </Stack>
                )
            },
        },

    ];

    const editHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKurumMailGonderimAyarlariDTO) => {
        dispatch(KurumMailGonderimAyarlariSlice.actions.setActiveRow(row));
        dispatch(KurumMailGonderimAyarlariSlice.actions.setOpen(true));


    }
    const deleteHandler = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: VwKurumMailGonderimAyarlariDTO) => {
        confirm({
            title: translate(translatePath, "Kayıt Silme"),
            description: translate(translatePath, "Seçili kaydı silmek istediğinize emin misiniz?"),
            variant: 'danger'
        }).then(async () => {

            await sil({ id: row.id })
                .unwrap()
                .then((e) => {
                    dispatch(KurumMailGonderimAyarlariSlice.actions.setData(state.data.filter((d) => d.id != row.id)));
                })
                .catch((e) => {
                    SnackbarUtils.error(translate(translatePath, e["message"]));
                });
        });
        dispatch(KurumMailGonderimAyarlariSlice.actions.setOpen(false));
    };
    const addHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(KurumMailGonderimAyarlariSlice.actions.setActiveRow(new VwKurumMailGonderimAyarlariDTO()));
        dispatch(KurumMailGonderimAyarlariSlice.actions.setOpen(true));
    }


    const searchHandlerClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (!state.searchHandler && !query.isFetching)
            dispatch(KurumMailGonderimAyarlariSlice.actions.setSearchHandler(true));
    };


    return (
        <Card>
            <CardContent>
                <DataGrid
                    enableQuickFilter
                    pinnedColumns={{ right: ["action"] }}
                    searchButton={<Button customType="search" loading={query.isFetching} onClick={searchHandlerClick} />}
                    loading={query.isFetching}
                    addButton={<Button customType="add" onClick={(e) => addHandler(e)} />}
                    sx={{ height: "70vh" }}
                    columns={columns}
                    rows={state.data ? state.data : []}
                />
            </CardContent>
        </Card>
    )
}
export default KurumMailGonderimAyarlariListe